declare const chrome:
  | {
      runtime?: {
        sendMessage?: (extensionId: string, message: unknown) => unknown
      }
    }
  | undefined

function sendToExtension(message: unknown): void {
  const extensionId = import.meta.env.VITE_EXTENSION_ID
  if (!extensionId || typeof chrome === 'undefined') return

  const sendMessage = chrome.runtime?.sendMessage
  if (typeof sendMessage !== 'function') return

  try {
    const result = sendMessage.call(chrome.runtime, extensionId, message)
    if (result && typeof (result as PromiseLike<unknown>).then === 'function') {
      Promise.resolve(result).catch(() => {
        // The extension may have no receiver or may disappear mid-message.
      })
    }
  } catch {
    // Extension messaging is best-effort. The runtime can disappear when the
    // extension is disabled, reloaded, or unavailable in the current browser.
  }
}

export function syncAuthToExtension(accessToken: string): void {
  sendToExtension({ type: 'PELGO_AUTH_SYNC', accessToken })
}

export function clearAuthFromExtension(): void {
  sendToExtension({ type: 'PELGO_AUTH_LOGOUT' })
}
